import { telaAberta } from './telaAberta';

/**
 * AS SUGESTÕES DA ABERTURA DO LUMOS, POR TELA (08/10/2026).
 *
 * Cada tela oferece o que faz sentido nela — e só o que o Lumos consegue
 * responder: uma ferramenta dele (agenda, funil, contratos, processo) ou um
 * guia do "Me mostra" (Captain::Copilot::Guias). Sugestão que ele não sabe
 * responder ensina a não perguntar. "Como está o meu dia?" vem antes, em
 * toda tela (o componente põe).
 */
const P = 'CAPTAIN.COPILOT.PROMPTS';
const item = (chave, icone) => ({
  label: `${P}.${chave}.LABEL`,
  prompt: `${P}.${chave}.CONTENT`,
  icone,
});

export const SUGESTOES_POR_TELA = {
  processo: [
    item('PROCESSO_RESUMO', 'i-ph-scales'),
    item('PROCESSO_FALTA', 'i-ph-list-checks'),
  ],
  processos: [
    item('PROCESSOS_ACHAR', 'i-ph-magnifying-glass'),
    item('PROCESSOS_RECURSO', 'i-ph-folder-plus'),
  ],
  agenda: [
    item('AGENDA_SEMANA', 'i-ph-calendar-dots'),
    item('AGENDA_ATRASADOS', 'i-ph-warning-circle'),
    item('AGENDA_AUDIENCIA', 'i-ph-gavel'),
  ],
  funil: [
    item('FUNIL_COMO_ESTA', 'i-ph-funnel'),
    item('FUNIL_NOVO', 'i-ph-plus-circle'),
  ],
  contratos: [item('CONTRATOS_VENCENDO', 'i-ph-file-text')],
  financeiro: [
    item('FINANCEIRO_LANCAR', 'i-ph-receipt'),
    item('CONTRATOS_VENCENDO', 'i-ph-file-text'),
  ],
  conversations: [
    item('SUMMARIZE', 'i-ph-text-align-left'),
    item('SUGGEST', 'i-ph-pencil-line'),
    item('RATE', 'i-ph-star'),
  ],
  dashboard: [
    item('HIGH_PRIORITY', 'i-ph-flag'),
    item('LIST_CONTACTS', 'i-ph-address-book'),
  ],
};

// Pelo NOME da rota, que é estável; o caminho só para as telas herdadas.
const PREFIXOS = [
  ['legal_processes_index', 'processos'],
  ['appointments_', 'agenda'],
  ['pipeline_', 'funil'],
  ['legal_contracts', 'contratos'],
  ['financial', 'financeiro'],
];

export const telaDoLumos = rota => {
  if (telaAberta(rota)?.tipo === 'processo') return 'processo';
  const nome = String(rota?.name || '');
  const achado = PREFIXOS.find(([prefixo]) => nome.startsWith(prefixo));
  if (achado) return achado[1];
  if (String(rota?.path || '').includes('/conversations'))
    return 'conversations';
  return 'dashboard';
};

export const sugestoesDaTela = rota => SUGESTOES_POR_TELA[telaDoLumos(rota)];
